import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../components/Button/Button';
import Content from '../../components/Content/Content';

const RequestAppealAlreadyReported = ({
  onHideRequestError,
  requestCausedError = 'appeal'
}) => (
  <Content>
    {requestCausedError === 'appeal' && (
      <>
        <Content.Title>
          Апелляция на результаты ГИА по этому предмету уже подавалась
        </Content.Title>
        <Content.Text>
          Можно подать только одну апелляцию на результаты ГИА по одному
          предмету.
        </Content.Text>
      </>
    )}
    {requestCausedError === 'denial' && (
      <>
        <Content.Title>
          Заявление на несоответствие бланков ответов/аудиозаписей устных
          ответов по этому предмету уже подавалась
        </Content.Title>
        <Content.Text>
          Можно подать только одно заявление на несоответствие бланков
          ответов/аудиозаписей устных ответов по одному предмету.
        </Content.Text>
      </>
    )}
    <Content.Button>
      <Button
        primary
        onClick={() => {
          onHideRequestError(true);
          window.scrollTo(0, 0);
        }}
      >
        Вернуться к списку предметов
      </Button>
    </Content.Button>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/otvet-obrazovanie/kak-zapisat-rebenka-v-shkolu/"
      >
        Как перевести ребенка в другую школу
      </a>
    </Content.Link>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/otvet-obrazovanie/kak-uznat-raspisanie-ege-oge-i-gve/"
      >
        Как узнать расписание ЕГЭ, ОГЭ и ГВЭ
      </a>
    </Content.Link>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/otvet-obrazovanie/kak-perevesti-bally-za-ege-i-oge-v-pyatiballnuyu-shkalu/"
      >
        Как перевести баллы за ЕГЭ и ОГЭ в пятибалльную шкалу
      </a>
    </Content.Link>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/search?category=instruction&hostApplied=false&page=1&q="
      >
        Все инструкции
      </a>
    </Content.Link>
  </Content>
);

RequestAppealAlreadyReported.propTypes = {
  requestCausedError: PropTypes.string,
  onHideRequestError: PropTypes.func.isRequired
};

export default RequestAppealAlreadyReported;
